import * as React from 'react'
import { ReactElement, useEffect, useState } from 'react'
import BaseTagPicker, { BaseTagPickerProps, useBaseStyles } from './BaseTagPicker'
import { ListItemDto } from '../../config/partyConfig'
import useEntity from '../../hooks/useEntity'
import { PartyFilterType } from '../../v2/pages/Party/BasePartyOverview'
import { PartyStatus } from '../Form/Party/PartyForm'

export type PartyPickerProps = Partial<BaseTagPickerProps<ListItemDto>> &
    Required<Pick<BaseTagPickerProps<ListItemDto>, 'selectedOptions' | 'onOptionsSelect'>> & {
        params?: PartyFilterType
    }

export default function PartyPicker(props: PartyPickerProps): ReactElement {
    const styles = useBaseStyles()

    const [sortedParties, setSortedParties] = useState<ListItemDto[]>([])
    const [parties] = useEntity<ListItemDto[]>(() => ({ url: '/party', params: props.params }), false)

    useEffect(() => {
        if (parties.loaded) {
            setSortedParties(parties.data)
        }
    }, [parties])

    return (
        <BaseTagPicker<ListItemDto>
            entities={sortedParties}
            alphabetical
            getEntityLabel={party => party.displayName.replaceAll('\n', ' ')}
            getEntityTagLabel={party => party.displayName.replaceAll('\n', ' ')}
            getEntityValue={party => party.id}
            getEntityTagSecondaryContent={party => party.displayName.replaceAll('\n', ' ')}
            getEntityClassName={party => (party.status === PartyStatus.Inactive ? [styles.archived] : [])}
            placeholderKey={'base.partypicker.placeholder'}
            {...props}
        />
    )
}
